<template>
  <v-form ref="roleForm">
    <v-text-field
      v-model="data.Nombre"
      :rules="rules.name"
      label="Nombre"
      outlined
      dense
      required
    ></v-text-field>

    <v-text-field
      v-model="data.CVESAT"
      :rules="rules.codigo"
      label="Código SAT"
      outlined
      dense
      required
    ></v-text-field>
    <v-switch
      v-model="generaiva"
      @change="toggleIva()"
      label="genera iva"
      color="primary"
      hide-details
    ></v-switch>
    <v-switch
      v-if="generaiva"
      v-model="useConfigIva"
      @change="toggleIva()"
      label="Usar Iva predeterminado"
      color="primary"
      hide-details
    ></v-switch>
    <v-text-field
      v-if="!useConfigIva && generaiva"
      v-model="data.Giva"
      class="mt-2"
      label="IVA"
      outlined
      dense
      required
    ></v-text-field>
    <div class="text-right">
      <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
      <v-btn style="margin-left: 6px" color="success" large @click="checkForm"
        >Guardar</v-btn
      >
    </div>
  </v-form>
</template>

<style scoped></style>

<script>
export default {
  name: "FamiliasForm",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      departamentos: [],
      data: {
        CVESAT: null,
        Nombre: null,
        Giva: false,
      },
      generaiva: false,
      useConfigIva: true,
      rules: {
        name: [(value) => !!value || "El nombre de la familia es obligatorio"],
        codigo: [(value) => !!value || "La clave SAT es obligatoria"],
      },
    };
  },
  methods: {
    checkForm() {
      if (this.$refs.roleForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.send(doAction);
      }
    },
    send(action) {
      const dataSave = this.data;
      if (action === "EDIT") {
        // id de edicion
        dataSave.Id = this.dataEdit.id;
      }
      if (typeof dataSave.Giva === "string") {
        dataSave.Giva = Number(dataSave.Giva);
      }

      this.$emit("successData", dataSave, action);
      //dataSave.Deptos = auxArrayDep;
    },
    toggleIva() {
      if (this.generaiva && this.useConfigIva) {
        this.data.Giva = Boolean(true);
      } else if (this.generaiva && !this.useConfigIva) {
        this.data.Giva = 16;
      } else {
        this.data.Giva = Boolean(false);
      }
    },
  },
  async mounted() {
    if (this.edit && this.dataEdit) {
      this.data.CVESAT = this.dataEdit.CVESAT || null;
      this.data.Nombre = this.dataEdit.Nombre || null;
      this.data.Giva = this.dataEdit.Giva ?? false;
      this.generaiva =
        this.dataEdit.Giva === true || typeof this.dataEdit.Giva === "number"
          ? true
          : false;
      this.useConfigIva = this.dataEdit.Giva === true ? true : false;
    }
  },
};
</script>
